<template>
  <Portal to="lefSideBar">
    <div class="login-form-wrapper">
      <div class="content text-center">
        <div class="logo">
          <img alt class="login-logo" src="@/assets/images/login-logo.png" />
          <img alt class="login-logo-text" src="@/assets/images/login-logo-text.png" />
        </div>
        <div class="login-text">– ログイン –</div>
        <div class="buttons">
          <button class="btn btn-success" @click="goToTeacherForm">先生ID</button>
          <button class="btn btn-success" @click="goToCorporationBrandSchoolForm">
            法人・ブランド・教場ID
          </button>
          <a href="https://www.miraiz.ai/" class="btn btn-success">生徒ID</a>
        </div>
        <div class="footer">©︎ 2020 Tamai Investment Educations Inc.</div>
      </div>
    </div>
  </Portal>
</template>

<script>
import { Portal } from 'portal-vue';
import { loggedIn, isLoginPath } from '@/helpers/Authentication.js';

export default {
  components: {
    Portal,
  },
  methods: {
    goToTeacherForm() {
      this.$router.push({ name: 'login_teacher' });
    },
    goToCorporationBrandSchoolForm() {
      this.$router.push({ name: 'login_corporation_brand_school' });
    },
  },
  computed: {
    ...loggedIn,
  },
  created() {
    if (this.loggedIn && isLoginPath(this.$route.fullPath)) {
      this.$router.push({ name: 'home' });
    }
  },
};
</script>

<style lang="scss" scoped>
.login-form-wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  .content {
    width: 100%;
    margin-top: -42px;
    .logo {
      text-align: center;
      display: block;
      margin-bottom: 70px;
      img {
        text-align: center;
        display: block;
        margin: auto;
        &.login-logo {
          margin-bottom: 15px;
          width: 50px;
        }
        &.login-logo-text {
          width: 118px;
        }
      }
    }
    .login-text {
      color: #42b195;
      font-size: 20px;
      margin-bottom: 40px;
    }
    .buttons {
      width: 100%;
      text-align: center;
      button,
      a {
        display: block;
        width: 65%;
        margin: 40px auto;
      }
    }
  }

  .footer {
    color: #7e7964;
    font-size: 8px;
    position: absolute;
    bottom: 0px;
    width: 100%;
  }

  form.loginForm {
    padding: 30px;
    text-align: left;
    .logo {
      text-align: center;
      display: block;
      margin-bottom: 14px;
      img {
        text-align: center;
        display: block;
        margin: auto;
        &.login-logo {
          margin-bottom: 15px;
          width: 50px;
        }
        &.login-logo-text {
          width: 118px;
        }
      }
    }
    .login-hint-label {
      height: 50px;
    }
    label {
      font-weight: bold;
    }
    input {
      border-radius: 12px;
    }
    .btn-login {
      margin-top: 10px;
      background-color: transparent;
      color: #28a745;
      padding: 4px 20px;
      border-radius: 4px;
    }
    .form-group {
      .form-login-icon {
        position: absolute;
        width: auto;
        bottom: 3px;
        right: 5px;
        margin-top: 0;
        font-size: 90%;
        color: #6c757dab;
      }
    }
  }
}
</style>
